

<template>
  <div class="login-page items-center justify-center">
    <v-card class="mx-auto item-card pt-12 pb-12">
      <div class="px-5">
        <div class="font-weight-bold px-5 title-step">
          Step 1: Use this information to broadcast
        </div>
        <div class="px-5 description">
          ( recommended tools:
          <a href="https://obsproject.com/" target="_blank">OBS</a>,
          <a href="https://streamlabs.com/" target="_blank">StreamLab</a>,
          <a href="https://www.twitch.tv/" target="_blank">Twitch</a>)
        </div>
        <br />
        <div class="font-weight-bold px-5 key-detail-title">URL Server</div>
        <v-row class="px-5">
          <v-col :cols="8" :lg="9" :md="12" :sm="8">
            <div class="box-disable">
              {{ streamStudio.streamDetail.streamURL }}
            </div>
          </v-col>
          <v-col :cols="4" :lg="3" :md="12" :sm="4">
            <v-btn
              class="d-flex align-center white-text-btn full-btn"
              color="#50ADDE"
              @click="copyToClipBoard(streamStudio.streamDetail.streamURL)"
              >Copy
            </v-btn>
          </v-col>
        </v-row>
        <br />
        <div class="font-weight-bold px-5 key-detail-title">Stream Key</div>
        <v-row class="px-5">
          <v-col :cols="8" :lg="9" :md="12" :sm="8">
            <div class="box-disable">
              {{ streamStudio.streamDetail.streamKey }}
            </div>
          </v-col>
          <v-col :cols="4" :lg="3" :md="12" :sm="4">
            <v-btn
              class="d-flex align-center white-text-btn full-btn"
              color="#50ADDE"
              @click="copyToClipBoard(streamStudio.streamDetail.streamKey)"
              >Copy
            </v-btn>
          </v-col>
        </v-row>

        <!-- <v-select
          :items="streamKeys"
          placeholder="Please select channel"
          item-text="title"
          item-value="_id"
          outlined
           class="md-w-100 xs-full-width m-auto"
        ></v-select>
        <div class="channelUsed md-w-100 xs-full-width m-auto">This channel is currently being used. Please select a new channel.</div> -->
        <br />
        <v-card-title primary-title class="font-weight-bold px-5 title-step"
          >Step 2: Please wait until the image appears.</v-card-title
        >
        <div class="px-5">
          <div id="video"></div>
        </div>
        <br />
        <br />
        <div class="text-center mt-2">
          <v-btn
            color="#E15752"
            class="xs-full-width white-text-btn"
            large
            rounded
            :disabled="!canPublish"
            @click="confirmPublishLive = true"
          ><v-icon class="live-icon">mdi-access-point</v-icon>Public this Live Event</v-btn>
        </div>
        <div class="text-center mt-2">
           <v-btn
              color="grey darken-1"
              class="ma-2 xs-full-width"
              large
              dark
              rounded
              outlined
              @click="cancelStream"
            >{{$vuetify.lang.t('$vuetify.cancel')}}</v-btn>
        </div>
      </div>
    </v-card>
    <v-dialog v-model="confirmPublishLive" max-width="350">
      <v-card class="pt-10">
        <v-card-text> Do you want to push notification to user? </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="openPushNoticeDialog">
            Yes, i want.
          </v-btn>
          <v-btn color="red darken-1" text @click="startStream">
            No, publish live now.
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <pushNoticeDialog
      :openDialogPushNotice.sync="isPushNoticeDialogOpen"
      :closePushNoticeDialog.sync="closePushNoticeDialog"
      :courseId.sync="courseId"
      :liveId.sync="liveId"
      :titleNotice.sync="titleNotice"
      :messageNotice.sync="messageNotice"
      :typeNotice.sync="typeNotice"
      :typeSpecial.sync="typeSpecial"
      :startStream.sync="startStream"
    >
    </pushNoticeDialog>
  </div>
</template>
<script>
import {
  getLiveStreamStudio,
  startLiveStream,
  cancelLiveStream,
} from "@/service/course/live";
import pushNoticeDialog from "@/views/course/dialog/pushNotificationDialog.vue";
export default {
  name: "setting-live",
  components: {
    pushNoticeDialog,
  },
  props: {
    openDialog: {
      type: Boolean,
    },
    liveId: {
      type: String,
    },
    courseId: {
      type: String,
    },
    changeStep: {
      type: Function,
    },
  },
  watch: {
    liveId(val) {
      console.log(this.openDialog);
      if (val) {
        // this.initial()
      }
    },
    openDialog(val) {
      console.log("close Setting", val);
      if (!val) {
        // this.initial()
        console.log("close Setting");
        // this.clearPlayer()
      }
    },
  },
  data() {
    return {
      confirmPublishLive: false,
      isPushNoticeDialogOpen: false,
      streamStudio: {
        streamDetail: {
          streamURL: "",
          streamKey: "",
          watchURL: "",
        },
      },
      canPublish: false,
      titleNotice: "Live Now !",
      messageNotice: "Couse live now",
      typeNotice: "LIVE",
      typeSpecial: "pageLive"
    };
  },
  async mounted() {
    let streamKeysResult = await getLiveStreamStudio({
      idlivestream: this.liveId,
    });
    this.streamStudio = streamKeysResult;
    await window.jwplayer("video").setup({
      sources: [{ file: this.streamStudio.streamDetail.watchURL }],
      width: "100%",
    });
    await window.jwplayer("video").on(
      "play",
      function (evt) {
        console.log("viewable", evt);
        // console.log("this.canPublish",this.canPublish)
        this.canPublish = true;
      }.bind(this)
    );
    await window.jwplayer("video").on(
      "error",
      function (evt) {
        console.log("evt", evt);
        this.canPublish = false;
        let timer = null;
        clearInterval(timer);
        window.jwplayer("video").stop();
        // while(repeat == true){
        timer = setTimeout(function () {
          window.jwplayer("video").play();
        }, 10000);
        // }
      }.bind(this)
    );
  },
  beforeDestroy() {
    this.clearPlayer();
  },
  methods: {
    async initial() {
      let streamKeysResult = await getLiveStreamStudio({
        idlivestream: this.liveId,
      });
      this.streamStudio = streamKeysResult;
      // let timer = null
      await window.jwplayer("video").setup({
        sources: [{ file: this.streamStudio.streamDetail.watchURL }],
        width: "100%",
      });
    },
    clearPlayer() {
      try {
        window.jwplayer("video").remove();
      } catch (err) {
        console.log(err);
      }
    },
    copyToClipBoard(text) {
      navigator.clipboard.writeText(text);
    },
    async startStream() {
      let result = await startLiveStream({ idlivestream: this.liveId });
      if (result.code == 403) {
        console.log(result.message);
      } else {
        await this.changeStep(3);
      }
    },
    async cancelStream() {
      let result = await cancelLiveStream({
        idcourse: this.courseId,
        idlivestream: this.liveId,
      });
      if (result.code == 403) {
        console.log(result.message);
      } else {
        await this.changeStep(1);
      }
    },
    async openPushNoticeDialog() {
      this.confirmPublishLive = false;
      this.isPushNoticeDialogOpen = true;
    },
    async closePushNoticeDialog() {
      this.isPushNoticeDialogOpen = false;
    },
  },
};
</script>
<style scoped>
.channelUsed {
  color: red;
  font-size: 14px;
}
.logo {
  /* width: 20%; */
  width: 180px;
  margin: 0 auto;
}
.login-page {
  /* height: 100%; */
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url("../../../../assets/bg-live.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.item-card {
  /* width: 30%; */
  min-height: 300px;
}

.md-w-100 {
  width: 50%;
}

.m-auto {
  margin: 0 auto !important;
}

.title-step {
  font-size: 18px;
}
.description {
  font-size: 14px;
  text-align: center;
}
.key-detail-title {
  font-size: 14px;
  font-weight: bold;
}
.box-disable {
  background-color: #f4f4f4;
  vertical-align: center;
  width: 100%;
  height: 100%;
  margin: auto;
  /* width: 60%; */
  /* border: 3px solid #73AD21; */
  padding: 6px;
}
a {
  text-decoration: blink;
}
.white-text-btn {
  color: white;
}
.full-btn {
  width: 100%;
}
.live-icon {
  padding-right: 10px;
}
.v-application .pt-12 {
  padding-top: 26px !important;
}
.v-btn:not(.v-btn--round).v-size--large {
  min-width: 262px;
}

@media only screen and (max-width: 768px) {
  .item-card {
    width: 100%;
    /* min-height: 90%; */
  }
  .login-page {
    /* height: 100%; */
    align-items: unset;
    padding: 20px;
  }
  .xs-full-width {
    width: 90% !important;
  }
}
@media only screen and (min-width: 769px) and (max-width: 1024px) {
  .item-card {
    width: 60%;
    min-height: 560px;
  }
  .or-line {
    width: 94%;
  }
  .login-page {
    /* height: 100%; */
    align-items: center;
    padding: 20px;
  }
  .xs-full-width {
    width: 90% !important;
  }
}
@media only screen and (min-width: 1025px) and (max-width: 1795px) {
  .item-card {
    width: 25%;
  }
}
@media only screen and (min-width: 1796px) {
  .item-card {
    width: 25%;
  }
}
</style>